export const DEFAULT_THEME_OPTIONS = [
  { value: 'original', label: 'Original', color: '#ff2e2e', logoImage: '', logoWideImage: '' },
  { value: 'light', label: 'Lys', color: '#d93636', logoImage: '', logoWideImage: '' },
  { value: 'colorful', label: 'Farget', color: '#ff3b30', logoImage: '', logoWideImage: '' },
  { value: 'blue', label: 'Blå', color: '#268cff', logoImage: '', logoWideImage: '' },
  { value: 'purple', label: 'Lilla', color: '#a855f7', logoImage: '', logoWideImage: '' },
  { value: 'green', label: 'Grønn', color: '#22c55e', logoImage: '', logoWideImage: '' },
  { value: 'yellow', label: 'Gul', color: '#ffc928', logoImage: '', logoWideImage: '' },
  { value: 'orange', label: 'Oransje', color: '#ff7a1a', logoImage: '', logoWideImage: '' },
];

export const normalizeThemeOptions = (options) => {
  const source = Array.isArray(options) && options.length ? options : DEFAULT_THEME_OPTIONS;
  const defaults = new Map(DEFAULT_THEME_OPTIONS.map((option) => [option.value, option]));
  const seen = new Set();

  return source.reduce((result, option) => {
    const value = typeof option.value === 'string' ? option.value.trim().toLowerCase() : '';
    if (!/^[a-z0-9][a-z0-9-]{0,30}$/.test(value) || seen.has(value)) return result;

    const fallback = defaults.get(value) || DEFAULT_THEME_OPTIONS[0];
    const color = /^#[\da-f]{6}$/i.test(option.color || '') ? option.color : fallback.color;
    seen.add(value);
    result.push({
      ...fallback,
      ...option,
      value,
      label: typeof option.label === 'string' && option.label.trim() ? option.label.trim() : value,
      color,
      logoImage: typeof option.logoImage === 'string' ? option.logoImage : '',
      logoWideImage: typeof option.logoWideImage === 'string' ? option.logoWideImage : '',
    });
    return result;
  }, []);
};